import React from 'react'

export default function ExportFileModal(props) {
  const { isExportModal, children } = props
  
  return (
    <>
      {isExportModal 
        ?
        <div>
          <div className="export-modal-container" data-test="export-modal-container">
            <div className="export-modal-content" data-test="export-modal-content">
              {children}
            </div>
          </div>
        </div>
        : 
        null
      }
    </>
  )
}
